var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Whatsapp--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Whatsapp Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.00033 0.879396C3.66533 0.880434 0.879026 3.67033 0.879041 7.00258 0.879047 8.20393 1.2366 9.39065 1.90395 10.3939L0.877136 13.1258l3.438404 -0.6218c0.83993 0.4105 1.76225 0.6162 2.68479 0.6168 3.33787 0.0023 6.12677 -2.7839 6.12677 -6.11822 0 -3.3305 -2.7899 -6.125154 -6.12677 -6.123184Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 596",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.33735 9.69922c0.82837 0.53178 1.69202 0.14446 2.29349 -0.30413 0.41546 -0.30986 0.40166 -0.9075 0.04682 -1.28526l-0.69971 -0.7449c-0.26542 0.26542 -0.78264 0.39679 -1.14201 0.28741 -0.77245 -0.23509 -1.09665 -0.6376 -1.35938 -1.04687 -0.30174 -0.47006 0.03901 -1.17209 0.30443 -1.4375l-0.77991 -0.71201c-0.3288 -0.30016 -0.82822 -0.35081 -1.1151 -0.01036 -0.56762 0.67358 -0.92063 1.69622 -0.50256 2.34737 0.7505 1.16892 1.78494 2.15586 2.95393 2.90625Z",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.8dbae6c108591cdf4c6bc4f62507ba07.svg";
export { ForwardRef as ReactComponent };